import { defineMessages } from "react-intl";

export const messages = defineMessages({
  stayDate: {
    id: "app.periodConditions.stayDate",
    description: "Stay dates",
    defaultMessage: "Stay dates",
  },
  startActive: {
    id: "app.periodConditions.startActive",
    description: "Stay active",
    defaultMessage: "Stay active",
  },
  endActive: {
    id: "app.periodConditions.endActive",
    description: "End active",
    defaultMessage: "End active",
  },
  bookingDate: {
    id: "app.periodConditions.bookingDate",
    description: "Stay dates",
    defaultMessage: "Stay dates",
  },
  startBookable: {
    id: "app.periodConditions.startActive",
    description: "Stay active",
    defaultMessage: "Stay active",
  },
  endBookable: {
    id: "app.periodConditions.endActive",
    description: "End active",
    defaultMessage: "End active",
  },
  weekDays: {
    id: "package.weekDays",
    description: "Week days",
    defaultMessage: "Weekdays",
  },
  weekDaysDescription: {
    id: "app.periodConditions.weekDaysDescription",
    description:
      "This rule will only apply if the time of the reservation occurs on any of the marked days (if all the fields are left empty it means they are enabled every day)",
    defaultMessage:
      "This rule will only apply if the time of the reservation occurs on any of the marked days (if all the fields are left empty it means they are enabled every day)",
  },
  hourRange: {
    id: "app.periodConditions.hoursRange",
    description: "Hour range",
    defaultMessage: "Hour range",
  },
  hourRangeDescription: {
    id: "app.periodConditions.hoursRangeDescription",
    description: "Hour range description",
    defaultMessage: "Hour range description",
  },
  monday: {
    id: "app.periodConditions.monday",
    description: "Monday",
    defaultMessage: "Monday",
  },
  tuesday: {
    id: "app.periodConditions.tuesday",
    description: "Tuesday",
    defaultMessage: "Tuesday",
  },
  wednesday: {
    id: "app.periodConditions.wednesday",
    description: "Wednesday",
    defaultMessage: "Wednesday",
  },
  thursday: {
    id: "app.periodConditions.thursday",
    description: "Thursday",
    defaultMessage: "Thursday",
  },
  friday: {
    id: "app.periodConditions.friday",
    description: "Friday",
    defaultMessage: "Friday",
  },
  saturday: {
    id: "app.periodConditions.saturday",
    description: "Saturday",
    defaultMessage: "Saturday",
  },
  sunday: {
    id: "app.periodConditions.sunday",
    description: "Sunday",
    defaultMessage: "Sunday",
  },
  start: {
    id: "app.periodConditions.start",
    description: "start",
    defaultMessage: "start",
  },
  end: {
    id: "app.periodConditions.end",
    description: "end",
    defaultMessage: "end",
  },
  addBookingDate: {
    id: "app.periodConditions.addBookingDate",
    description: "Add booking date",
    defaultMessage: "Add booking date",
  },
  deleteBookingDate: {
    id: "app.periodConditions.deleteBookingDate",
    description: "Remove booking date",
    defaultMessage: "Remove booking date",
  },
  endDateAfterStart: {
    id: "app.periodConditions.endDateAfterStart",
    description: "The end date must be greater than the start date and greater than today",
    defaultMessage: "The end date must be greater than the start date and greater than today",
  },
  save: {
    id: "default.save",
    defaultMessage: "Save",
  },
});
